var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBeemgIconsGreenUpArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.4401 16.42L21.7201 9.86004L16.0001 3.29004L10.2801 9.86004L4.56006 16.42H9.77006V28.71H22.2301V16.42H27.4401Z",
    fill: "#17A32B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeemgIconsGreenUpArrow);
export default __webpack_public_path__ + "static/media/beemg-icons-green-up-arrow.4c9d82f8361d38ed3c1d9da684f379f5.svg";
export { ForwardRef as ReactComponent };